//
// NOTE:  The popup has some limitless template stuff in it.  When we get the the public (web client)
// site we can make a separate version for it.
//

//Popups designed to be used with bootstrap.  
//
//
//methods:
//  open(options) - opens a popup
//  close($popup) - closes the popup, $popup is a jQuery object passed to the various callback functions.
//
//
//options:
//  type: shows the popup, types are "alert", "confirm", "form", "generic".  Default is generic
//  title: the popup title,
//  content:  the content for the popup
//  css: additional css class for popup
//  url: url to retrieve the content.  If url is specified the content property is ignored.
//  DEPRECATED: width: optional, width of popup in pixels.  Use classes defined by limitless on cssClass property
//  okButtonText: optional, text for primary button, default is ok
//  suppressCloseX: optional, if true hides the X in the upper right of the dialog.
//  buttons: optional, see below
//
//callbacks:  callbacks are part of options.  All callbacks are passed a $popup object that is the jQuery popup.
//  afterOpen: called after the popup is shown
//  afterClose: called after the popup is hidden and before it is destroyed
//  okCallback:  called after OK or Save is clicked and before the popup is closed.  Return false to keep the popup open.
//  cancelCallback: called after Cancel of the top X button is clicked and before the popup is closed.  Return false to keep the popup open.
//  serverValidationFailedCallback:  (type=form only)called after Save is clicked and form passes client validation but fails server validation.  In this case
//                                   the popup form is returned via ajax and updated in the popup to allow for updated error messages.  This
//                                   callback is called after the form is updated.
//
//types:
//  alert
//      Close button, fires cancelCallback
//  confirm
//      Ok button, fires okCallback
//      Cancel, fires cancelCallback
//  form
//      Save button, fires okCallback after post if client and server validation passes, fires serverValidationFailedCallback if server validation fails.
//      Cancel button, fires cancelCallback
//      
//  generic
//      buttons must be provided manually
//
//buttons: custom buttons can be specified for "form" and "generic" popups.  
//buttons: [
//  {
//      text: text or html for button,
//      isOk: true for Ok button, fires okCallback.  If type="form" it will fire serverValidationFailedCallback when appropriate
//      isCancel: true for cancel button, fires cancelCallback
//      isPrimary: default to true if isOk=true, otherwise default to false.  If true class="btn-primary" is added.
//      width: default is null, useful if you want all buttons to be the same size.
//      callback: custom functions for buttons when isOk=false and isCancel=false, ignored if isOk=true or isCancel=true.  
//                $popup is passed to custom functions.
//  },
//  {another button}
//]




/*
Limitless:

<!-- Modal with h3 -->
<div id="modal_h3" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">H3 heading title</h3>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <h6 class="font-weight-semibold">Text in a modal</h6>
                <p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>

                <hr>

                <h6 class="font-weight-semibold">Another paragraph</h6>
                <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-link" data-dismiss="modal">Close</button>
                <button type="button" class="btn bg-primary">Save changes</button>
            </div>
        </div>
    </div>
</div>


// code to trigger
<tr>
    <td>Modal with H3 heading</td>
    <td><button type="button" class="btn btn-light" data-toggle="modal" data-target="#modal_h3">Launch <i class="icon-play3 ml-2"></i></button></td>
    <td>Modal title in <code>H3</code> size</td>
</tr>

*/



;ailtire.popup = function() {
    var

    //
    //open the popup
    //
    openPopup = function(options) {
        //merge the settings
        getSettings(
            options,
            function (settings) {
                //create the popup
                var $popup = createPopup(settings);

                //setup the form
                if (settings.type == "form") {
                    setupForm($popup, settings);
                }

                //define the buttons
                defineButtons(settings);

                //add the buttons and events
                setupButtons($popup, settings);


                //show it
                $popup.modal("show");


                //afterOpen callback
                if (settings.afterOpen) {
                    settings.afterOpen($popup);
                }
            }
        )
    },


    //
    //close the popup.  This is used for a form popup when you need to close it manually, $popup is the model popup returned by the 
    //various form callback functions.
    //
    closePopup = function($popup) {
        $popup.modal("hide");
    },


    //
    //private method to retrieve the default settings and merge the user options.
    //
    getSettings = function(options, callback) {
        //defult settings for options.  We're defining them all here but some are not used by some popups.
        var defaults = {
            type: "generic",
            title: null,
            content:  null,
            css: null,
            url: null,
            width: null,
            afterOpen: null,
            afterClosed: null,
            okCallback:  null,
            cancelCallback: null,
            saveCallback:  null,
            serverValidationFailedCallback:  null,
            cancelCallback: null,
            buttons: null,
            cssClass: null,      //css class added to modal
            okButtonText: null,
            suppressCloseX: false
        };

        //merge the options and defaults
        var settings = $.extend({}, defaults, options);

        if (settings.okButtonText == null || settings.okButtonText == '') {
            settings.okButtonText = 'Ok';
        }

        if (options.url) {
            //get the content from the server.
            rezcare.ajax.get(
                settings.url,
                function(html) {
                    settings.content = html;
                    callback(settings);
                }
            );
        } else {
            //just return the settings
            callback(settings);
        }
    },


    //
    //helper method to create the popup
    //
    createPopup = function(settings) {
        //need to find an unused id
        var cnt = 0;
        var id = "";
        do {
            cnt++;
            id = "autoPopup_" + cnt;
        } while($("#" + id).length > 0)



        //setup the extras style if width was specified the width if not specified
        var style = "";
        if (settings.width) {
            //left margin = -1/2 of width
            style = " style='width:" + settings.width + "px;";
            //style += "margin-left: -" + parseInt(width)/2 + "px;";
            style += "'";
        }

        //create the popup html
        var s = "<div id='" + id + "' class='modal fade"
        if (settings.cssClass) {
            s += " " + settings.cssClass;
        }
        s += "'>";
        s += "<div class='modal-dialog modal-dialog-scrollable " + (settings.css ? settings.css : "") + "'" + style + ">";
        s += "<div class='modal-content'>";

        //create the header
        s += "<div class='modal-header pb-2'>";
        // s += "<button type='button' class='close' data-dismiss='modal' aria-hidden='true' data-btn-type='cancel'>&times;</button>";
        s += "<h3 class='modal-title'>";
        if (settings.title) {
            s += settings.title;
        }
        s += "</h3>";
        if (!settings.suppressCloseX) {
            s += "<button type='button' class='close' data-bs-dismiss='modal'>&times;</button>";
        }
        s += "</div>";

        //create the modal body
        s += "<div class='modal-body'>";
        if (settings.type != "form") {
            //forms add content in setupForm
            s += settings.content;
        }
        s += "</div>";

        //create the footer, and buttons
        s += "<div class='modal-footer pt-3'>";
        s += "</div>";

        //close the main div.modal
        s += "</div></div></div>";

        //add it to the body
        $("body").append(s);

        //get a reference to the modal div we just added and create the modal object
        var $popup = $("#" + id);
        $popup.modal({show: false, backdrop: "static"});

        // //if scrolling contents
        // if (settings.scrollContents) {
        //     //need to set to invisible
        //     $popup.css("visibility", "hidden");

        //     //calc if it will be larger than the screen
        //     $popup.on("shown.bs.modal", function () {
        //         //popup height with margins
        //         var popupOuterHeight = $popup.find(".modal-dialog").outerHeight(true);

        //         //window height
        //         var windowHeight = $(window).height();

        //         //if it's too big
        //         if (popupOuterHeight > windowHeight) {
        //             //get the difference
        //             var delta = popupOuterHeight - windowHeight;

        //             //get the popup body
        //             var $popBody = $popup.find(".modal-body");
        //             var bodyH = $popBody.outerHeight();

        //             //new body height
        //             var newBodyH = bodyH - delta;

        //             //apply the new body height
        //             if (newBodyH > 100) {
        //                 $popBody.css("overflow-y", "scroll").css("height", newBodyH + "px").scrollTop(0);
        //             }
        //         }

        //         $popup.css("visibility", "visible");
        //     });

        // }

        $popup.modal("show");

        //hookup the hidden event to remove it
        $popup.on("hidden.bs.modal", function() {
            //after closed callback
            if (settings.afterClose) {
                settings.afterClose($popup);
            }

            //remove it
            $popup.remove();
        });

        //return the opener
        return $popup;
    },
    
    //
    //define the buttons for the popup
    //
    defineButtons = function(settings) {
        if (settings.type == "alert") {
            //alert box buttons
            settings.buttons = [
                {text: settings.okButtonText, isOk: true, isPrimary: true}
            ];
        } else if (settings.type == "confirm") {
            //confirm box buttons
            settings.buttons = [
                {text: settings.okButtonText, isOk: true, isPrimary: true},
                {text: "Cancel", isCancel: true}
            ];
        } else if (settings.type == "form") {
            //form, only if no custom buttons
            if (settings.buttons == null) {
                settings.buttons = [
                    {text: "Save", isOk: true, isPrimary: true},
                    {text: "Cancel", isCancel: true}
                ];
            }
        }

        //merge the buttons with default values so they have all props defined
        if (settings.buttons) {
            var defaults = {text:null, isOk:false, isCancel:false, isPrimary:false, width:null, callback: null};
            for(var i=0; i<settings.buttons.length; i++) {
                settings.buttons[i] = $.extend({}, defaults, settings.buttons[i]);
            }
        }
    },
    
    //
    //add the buttons to the popup and setup the events
    //
    setupButtons = function($popup, settings) {
        //get the footer
        var $footer = $popup.find(".modal-footer");

        //create each button and add it
        if (settings.buttons) {
            for(var i=0; i<settings.buttons.length; i++) {
                var b = settings.buttons[i];

                var $btn = $("<button class='btn' type='button' data-btn-index='" + i + "'>" + b.text + "</button>");

                // // Add custom RMAU button class
                // $btn.addClass("btn-RMAU");

                if (b.isPrimary) {
                    $btn.addClass("btn-primary");
                } else {
                    $btn.addClass("btn-light");
                }
                if (b.isCancel) {
                    $btn.attr("data-bs-dismiss", "modal");
                }
                if (b.width) {
                    $btn.css("width", b.width + "px");
                }
                //add data- attributes if isOk or isCancel
                if (b.isOk) {
                    $btn.attr("data-btn-type", "ok");
                }
                if (b.isCancel) {
                    $btn.attr("data-btn-type", "cancel");
                }

                //add to the footer
                $footer.append($btn);

                //add the custom function, on if !isOk and !isCancel
                if (!b.isOk && !b.isCancel && b.callback != null) {
                    $btn.click(function() {
                        //disable the button
                        $(this).attr("disabled", true);

                        //get the index
                        var idx = parseInt($(this).attr("data-btn-index"));

                        //need to call using original array, since this won't execute until later it will have a value of b that is the last 
                        //element of the index
                        settings.buttons[idx].callback($popup);

                        //enable the button
                        $(this).attr("disabled", false);
                    });
                }
            }
        }

        //cancelCallback
        if (settings.cancelCallback) {
            //need to hookup to any cancel buttons and the top X in the header
            //there may be multiple buttons
            var $cancel = $popup.find(".modal-header button[data-btn-type='cancel'], .modal-footer button[data-btn-type='cancel']");

            //remove the auto-close mechanism
            $cancel.removeAttr("data-dismiss");

            //hookup the click function
            $cancel.click(function() {
                //disable the buttons
                $cancel.attr("disabled", true);

                //close flag
                var close = true;

                //callback
                if (settings.cancelCallback($popup) == false) {
                    close = false;
                }

                //close or re-enable the buttons
                if (close) {
                    //close
                    $popup.modal("hide");
                } else {
                    //enable the buttons
                    $cancel.attr("disabled", false);
                }
            });
        }

        //ok buttons for non-form, we need to hook these up even if there is no callback
        if (settings.type != "form") {
            //get the ok button, there may be multiples
            var $ok = $popup.find(".modal-footer button[data-btn-type='ok']");

            //if any found
            if ($ok.length > 0) {
                //hookup click
                $ok.click(function() {
                    //close flag
                    var close = true;

                    //callback
                    if (settings.okCallback) {
                        //disable the button
                        $ok.attr("disabled", true);

                        //call it
                        if (settings.okCallback($popup) == false) {
                            close = false;
                        }
                    }

                    //close
                    if (close) {
                        $popup.modal("hide");
                    } else {
                        //enable the buttons
                        $ok.attr("disabled", false);
                    }
                });
            }
        }

        //ok button for form
        if (settings.type == "form") {
            //get the ok button, there may be multiples
            var $ok = $popup.find(".modal-footer button[data-btn-type='ok']");

            //if any found
            if ($ok.length > 0) {
                $ok.click(function() {
                    //disable the buttons
                    $ok.attr("disabled", true);

                    //get the body & form 
                    var $frm = $popup.find("form");
                    var $body = $frm.find(".modal-body");

                    //we can't let MVC submit normally, we need to jump in the middle
                    //$frm.valid() will fire client side validation
                    if ($frm.valid()) {
                        //passed client validation, now we need to call the server and let it validate
                        //post must return a PopupResult
                        $.post(
                            $frm.attr("action"),
                            $frm.serialize(),
                            function(json) {
                                if (json.isValid) {
                                    if (settings.okCallback) {
                                        //close flag
                                        var close = true;

                                        //callback
                                        if (settings.okCallback($popup) == false) {
                                            close = false;
                                        }

                                        //close it
                                        if (close) {
                                            $popup.modal("hide");
                                        } else {
                                            //don't close, just reenable the button
                                            $ok.attr("disabled", false);
                                        }
                                    } else if (json.url && json.url != "") {
                                        window.location = json.url;
                                    } else {
                                        $popup.modal("hide");
                                    }
                                    //window.location = json.url;
                                } else if (json.TimeoutUrl) {
                                    window.location = json.TimeoutUrl;
                                } else {
                                    //it's not valid, insert the html (after extracting the form) into the body
                                    $body.html(extractForm(json.html).$html);

                                    //sroll to top so any errors are shown
                                    $body.scrollTop(0);

                                    //setup the date picker
                                    adc.utility.datePicker($body);

                                    //fix up the client validation, this is running against the original $frm which is still valid.
                                    $frm.removeData("validator");
                                    $frm.removeData("unobtrusiveValidation");
                                    $.validator.unobtrusive.parse($frm);

                                    //validation failed callback
                                    if (settings.serverValidationFailedCallback) {
                                        settings.serverValidationFailedCallback($popup);
                                    }

                                    //enable the button
                                    $ok.attr("disabled", false);
                                }
                            }
                        );
                    } else {
                        //didn't pass client validation, sroll to top so any errors are shown
                        $body.scrollTop(0);

                        //enable the button
                        $ok.attr("disabled", false);
                    }
                });
            }
        }
    },
    
    //
    //private method to load the form html. called for popup forms
    //
    setupForm = function($popup, settings) {
        //now we need to rearrange some stuff.  We can't just stick the html in the modal-body because we need the
        //buttons that are in modal-footer inside the form tag.

        //extract the form, leaving the rest of the html intact
        var e = extractForm(settings.content);
        var $html = e.$html;
        var $frm = e.$frm;

        //find the content & empty it
        $content = $popup.find(".modal-content");

        //remove the body and footer
        var $body = $content.find(".modal-body");
        var $footer = $content.find(".modal-footer");
        $body.remove();
        $footer.remove();

        //now add the form to the modal
        $popup.append($frm);
        $content.append($frm);

        //add the body & footer to the form
        $frm.append($body).append($footer);

        //now add the html to the body
        $body.append($html);

        //setup the date picker
        rezcare.utility.datePicker($body);

        //this will fix it up so the ajax validation works
        $frm.removeData("validator");
        $frm.removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse($frm);

        //set focus
        $popup.on("shown.bs.modal", function () {
            rezcare.utility.focus($frm);
        });
    },
    
    //
    //private method to extract the form element, leaving the forms children in place, called by loadForm
    //
    extractForm = function(html) {
        //for some reason, extra line breaks at the beginning of the PartialView break the $(html) call.  Trim them off.
        html = $.trim(html);

        //get the html as a jQuery object
        var $html = $(html);

        //get the form tag
        var $frm = $html.find("form");

        //the above will fail if <form> is the outer most tag, try again by wrapping it with a div
        if ($frm.length == 0) {
            $html = $("<div>" + html + "</div>");
            $frm = $html.find("form");
        }


        //insure there's only one form tag
        if ($frm.length != 1) {
            alert("there must be exactly 1 form tag to use it within a popup");
            return;
        }


        //remove the form contents and readd after the form tag
        var frmInner = $frm.html();
        $frm.empty();
        $frm.after(frmInner);
        $frm.remove();

        //return the html & form
        return {
            $html: $html,
            $frm: $frm
        }
    };


    //return methods
    return {
        open: openPopup,
        close: closePopup
    };
}();